// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#000000, #04141f, #0a3a57, #1b7fb8, #0a3a57, #04141f, #000000",
  firstName: "Jamie",
  middleName: "",
  lastName: "Waters",
  message: "Production Engineer & Technical Director",
  icons: [
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/housane12/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/jamie-waters-450a021b5/",
    },
    {
      image: "fa-facebook",
      url: "https://www.facebook.com/share/YCuzcHP9ZZG4Tqss/?mibextid=LQQJ4d",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/jamie.png"),
  imageSize: 375,
  message:
    "I'm a freelance Production Engineer and Technical Director working across UK theatre, touring, and live events—with production sound and video engineering at the core of my practice. Eight years of technical experience, four of them professional, have taken me from Deputy Head of Video at Pleasance Edinburgh to touring nationally with Northern Stage. I thrive on the creative problem-solving that production engineering demands: adapting systems to unfamiliar venues, solving under pressure, and making ambitious work happen safely. Beyond the desk, I hold FREC 4, SALMS, and MIMMS qualifications and work as a medical responder at events and sports fixtures. I'm particularly passionate about immersive and semi-immersive theatre, and how technical craft can draw an audience into a deeper connection with the story.",
  resume: "https://nextcloud.housane.co.uk/s/FNGAdWo3AXgC7LA",
};

// Leadership SECTION
const leadership = {
  show: true,
  heading: "Recent Projects",
  message:
    "Here is a selection of my recent work",
  images: [
    { 
      img: require("../editable-stuff/othello.png"), 
      label: "Video Programmer / Production Video & Sound Engineer — Othello (Northern Stage National Tour)", 
      paragraph: "Served as lead video programmer and production sound/video engineer on national theatre tour (Sep–Nov 2026). Designed and implemented video content cues integrating QLab with lighting and audio systems across multiple venue environments. Adapted show systems for diverse regional theatre spaces. Photo Credit: Marc Brenner" 
    },
    { 
      img: require("../editable-stuff/cof.png"), 
      label: "Sound & Video Technician - Circle of Fifths", 
      paragraph: "This was a small scale Welsh tour exploring the rituals around death and dying in the Butetown community. I was responsible for all of the Sound and Video aspects of the show while on tour, as well as responsible for Sound through the rehearsal process." 
    },
    { 
      img: require("../editable-stuff/darksl.png"), 
      label: "Technical Director - Dark Slate Theatre Company", 
      paragraph: "Coordinating all things technical across our shows most recently on The Unspoken. We take influence from film noir, German expressionism, and immersive theatre creating unique and engaging experiences for our audiences" 
    },
        { 
      img: require("../editable-stuff/gsa.png"), 
      label: "Production Sound Engineer - GSA MA Plays 2024", 
      paragraph: "Installing and maintaining the sound system for *The Unmanageable Sisters* and *Pericles*" 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: false,
  heading: "Skills",
  hardSkills: [
    { name: "Q-Lab", value: 80 },
    { name: "ETC Eos", value: 65 },
    { name: "dlive", value: 70 },
    { name: "Project Management", value: 70 },
  ]
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for freelance opportunities in and around the Peak District, if you think there's a project we could work on together please reach out:",
  email: "admin@jrwtechnical.uk",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: false,
  heading: "Recent Projects",
  gitHubUsername: "judoguy12", //i.e."johnDoe12Gh"
  reposLength: 4,
  specificRepos: [],
};

const experiences = {
  show: true,
  heading: "Skills",
  data: [
    {
      role: 'Dante Networking Lvl 3',// Here Add Company Name
      date: 'Achieved June 2024',
    },
    {
      role: 'FREC 4 (First Responder)',
      date: 'Enhanced with SALMS and MIMMS',
    },
    {
      role: 'Q-Lab',
      date: 'Solid understanding of Q-Lab networking, sound and video',
    },
    {
      role: 'Desks I have worked on',
      date: 'X32, dLive, Yamaha CL/QL, DiGiCo, SQ series',
    },
    {
      role: 'Technical Management',
      date: 'Experience accros a variety of projects from live music to musicals to theatre shows with both large and small teams',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, skills, leadership, getInTouch, repos, experiences };
